export const GROUP_INVITATION_REQUEST_TYPE = {
  NOT_SPECIFIED: "NOT_SPECIFIED",
  COMPANY_GROUP_INVITE: "COMPANY_GROUP_INVITE",
  CRM_INVITE: "CRM_INVITE",
  ACCOUNTANT_INVITE: "ACCOUNTANT_INVITE",
  GROUP_JOIN_REQUEST: "GROUP_JOIN_REQUEST",
  PERSONAL_TAX_INVITE: "PERSONAL_TAX_INVITE",
} as const;
